export default __webpack_public_path__ + "static/media/marketing.0be3e685.webp";